var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaratLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.554 4.808L4.589.337 5.801 1.68 2.979 4.808l2.822 3.129L4.589 9.28z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjEwIiBmaWxsPSIjMDA0YTg1Ij4KICAgIDxwYXRoIGQ9Ik0uNTU0IDQuODA4TDQuNTg5LjMzNyA1LjgwMSAxLjY4IDIuOTc5IDQuODA4bDIuODIyIDMuMTI5TDQuNTg5IDkuMjh6IiBmaWxsPSIjMDA0YTg1IiAvPgo8L3N2Zz4K";
export { SvgCaratLeftSmall as ReactComponent };